import React from 'react';
import PropTypes from 'prop-types';

import { PhoneFormat, Input } from '../../index';

export const HospitalInfoForm = ({ onChange, data, errors, contactName, disabled }) => {
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                rowGap: '5px',
            }}
        >
            <Input
                id="name"
                name="name"
                type="text"
                label="Counseling Service name"
                placeholder="Counseling Service name"
                required
                onChange={onChange}
                value={data?.name}
                $inputMaxWidth="400px"
                helperText={errors.find((error) => error.property === 'name')?.message}
                disabled={disabled}
                max={100}
            />

            <Input
                id="hospitalID"
                name="hospitalID"
                type="text"
                label="Counseling Service ID"
                placeholder="Counseling Service ID"
                required
                onChange={onChange}
                value={data?.hospitalID}
                $inputMaxWidth="400px"
                disabled
                helperText={errors.find((error) => error.property === 'hospitalID')?.message}
                max={30}
            />

            {contactName && (
                <Input
                    id="contactName"
                    name="contactName"
                    type="text"
                    label="Contract name"
                    placeholder="Contact name"
                    required
                    onChange={onChange}
                    value={data?.contactName}
                    $inputMaxWidth="400px"
                    helperText={errors.find((error) => error.property === 'contactName')?.message}
                    disabled={disabled}
                    max={50}
                />
            )}

            <div
                style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(2,280px)',
                    columnGap: '15px',
                }}
            >
                <Input
                    id="email"
                    label="Contact mail"
                    placeholder="Contact mail"
                    name="email"
                    type="email"
                    value={data?.email}
                    onChange={onChange}
                    required
                    helperText={errors.find((error) => error.property === 'email')?.message}
                    disabled={disabled}
                    max={50}
                />
                <Input
                    id="phoneNumber"
                    label="Contact number"
                    placeholder="Contact number"
                    name="phoneNumber"
                    value={data?.phoneNumber}
                    onChange={onChange}
                    required
                    InputProps={{
                        inputComponent: PhoneFormat,
                    }}
                    helperText={errors.find((error) => error.property === 'phoneNumber')?.message}
                    disabled={disabled}
                />
            </div>
            <Input
                id="address"
                label="Address"
                placeholder="Address"
                name="address"
                value={data?.address}
                onChange={onChange}
                required
                helperText={errors.find((error) => error.property === 'address')?.message}
                disabled={disabled}
                max={100}
            />
        </div>
    );
};

HospitalInfoForm.propTypes = {
    data: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    errors: PropTypes.array.isRequired,
    contactName: PropTypes.bool,
    disabled: PropTypes.bool,
};
